import Player from '@vimeo/player';

import globals from'../globals.js';

import load_image from'../helpers/image-loader.js';
import load_video from'../helpers/video-loader.js';

import hoverintent from 'hoverintent';

window.curTime = 0;
window.killTimer = false;

window.volume = 0;


function video(){

    var players = document.querySelectorAll('.player');
    var videos = Array.prototype.slice.call(players);
    var vimeoPlayers = [];

    var fullScreen = document.querySelector('.full-video-player');
   
    if(fullScreen){
        var playlist = document.querySelector('.playlist');

        if(playlist){
            var opts = {
                timeout: 1000,
                interval: 50, 
                sensitivity: 100
            };

            document.body.classList.add('dark');

            hoverintent(playlist,
            function() {
                document.body.classList.add('playlist-hover');
                document.body.classList.add('hovering-over');
            }, function() {
                document.body.classList.remove('playlist-hover');
                document.body.classList.remove('hovering-over');
            }).options(opts);

            playlist.addEventListener('touchend', function(e){
                if( !document.body.classList.contains('playlist-hover')){
                    e.preventDefault();
                    document.body.classList.add('playlist-hover')
                }
            });
        
        }

        fullScreen.addEventListener('touchend', function(e){
            if( document.body.classList.contains('playlist-hover')){
                document.body.classList.remove('playlist-hover')
            }
        });

        
    


        window.removeEventListener("wheel", wheelReveal);
        window.addEventListener("wheel", wheelReveal);
            
    
        function wheelReveal(e) {
            if(!document.body.classList.contains('hovering-over') && document.querySelector('.playlist')){
                if(e.deltaY > 1){
                    document.body.classList.add('playlist-hover');
                }else{
                    document.body.classList.remove('playlist-hover');
                }
            }        
        }
          
    }

    

    var autoplay = false;

    if(window.curTime > 0 && fullScreen ){
        autoplay = true;
    }



    for (let a = 0; a < videos.length; a++) {

        let vid = videos[a];

        if(autoplay){
            bind_player(vid);
        }else{

            const center = vid.parentNode.querySelector('.video-center');
            const loader = center.previousElementSibling;
            const embedWrap = vid.parentNode;
    
            center.addEventListener("click", function(){
                window.curTime = 0;
                bind_player(vid);
            });

        }
    }
   
    function bind_player(vid){

        const center = vid.parentNode.querySelector('.video-center');
        const loader = center.previousElementSibling;
        const embedWrap = vid.parentNode;

        for (let a = 0; a < vimeoPlayers.length; a++) {
            vimeoPlayers[a].pause();   
        }

        let sound = 1;
        
        if(window.volume){
            sound = 0;
            embedWrap.classList.remove('muted');
        }else{
            embedWrap.classList.add('muted');
        }

        const options = {
            id: vid.id,
            resoponsive: true,
            loop: false,
            controls: false,
            autopause: true,
            muted: sound,
            cache: true,
            dnt: true,
        };

        
        const player = new Player(vid, options);
        vimeoPlayers.push(player);
 
        embedWrap.classList.add('trig');
        player.setCurrentTime(window.curTime);
        player.play();
 
        window.curTime = 0;

        embedWrap.addEventListener('click', function(){
            if(document.querySelector('.playing')){
                document.body.classList.remove('playlist-hover');
            }
        });

        var timeWatched = 0;
        var timeWatchedElm = embedWrap.querySelectorAll('.marker')[0];
        var timeWatchedNumElm = embedWrap.querySelectorAll('.watched')[0];

        var duration = 0;
        var durationElm = 0;
        var durationNumElm = embedWrap.querySelectorAll('.duration')[0];

        var loadProgress = embedWrap.querySelectorAll('.load-progress')[0];

        var playTrack = embedWrap.querySelectorAll('.mouse-track')[0];
        var scrubTo = embedWrap.querySelectorAll('.scrub-to')[0];

        var soundElm = embedWrap.querySelectorAll('.sound-control')[0];
        var playbackElm = embedWrap.querySelectorAll('.playback-control')[0];

        var fullScreenButton =  embedWrap.querySelector('.full-screen-control');
        var expandButton =  embedWrap.querySelector('.expand-video');

        var dragStat = false;
        var dragTimer = 100;
        var dragTimerCount = 0;
        var lastDrag = 0;

        playTrack.addEventListener('mousemove', function(e){
            e.preventDefault();
            var seconds = updateTrack(e, playTrack, scrubTo, duration);
            if(dragStat){
                let secondsSince = Math.floor(new Date() - lastDrag);
                if(secondsSince >= dragTimer){
                    lastDrag = new Date();
                    updateVideo(e);
                }
            }
        });

        playTrack.addEventListener('mousedown', function(e){
            e.preventDefault();
            playTrack.classList.add('focus');
            dragStat = true;
            lastDrag = new Date();
        });

        playTrack.addEventListener('mouseleave', function(e){
            e.preventDefault();
            playTrack.classList.remove('focus');
            dragStat = false;
        });

        playTrack.addEventListener('mouseup', function(e){
            e.preventDefault();
            playTrack.classList.remove('focus');
            dragStat = false;
        });

        playTrack.addEventListener('click', function(e){
            e.preventDefault();
            updateVideo(e);
        });

        function updateVideo(e){
            var seconds = updateTrack(e, playTrack, scrubTo, duration);
            timeWatchedElm.style.width = (seconds/duration) * 100 + '%';
            player.setCurrentTime(seconds);
        };

        soundElm.addEventListener('click', function(e){
            e.preventDefault();
            player.getVolume().then(function(volume) {
                if(!volume){
                    player.setVolume(1);
                    window.volume = 1;
                    embedWrap.classList.remove('muted');
                }else{
                    player.setVolume(0);
                    window.volume = 0;
                    embedWrap.classList.add('muted');
                }
            });
        });



        fullScreenButton.addEventListener('click', function(e){
            e.preventDefault();
    
            if (!document.fullscreenElement && !document.mozFullScreenElement && !document.webkitFullscreenElement && !document.msFullscreenElement ) {
        
                var requestMethod = embedWrap.requestFullScreen ||
                embedWrap.webkitRequestFullscreen ||
                embedWrap.mozRequestFullScreen ||
                embedWrap.msRequestFullscreen;
                
        
                if( requestMethod ) {
                    requestMethod.apply(embedWrap);
                    document.body.classList.add('fullscreen-mode');
                }else{
                    player.requestFullscreen().catch((error) => {
                        console.error("Error entering fullscreen:", error);
                    });
                }
                
              
        
            }else{
                
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.webkitExitFullscreen) {
                    document.webkitExitFullscreen();
                }  
                  
                  document.body.classList.remove('fullscreen-mode');
            }
        });

        playbackElm.addEventListener('click', function(e){
            e.preventDefault();
            

            player.getPaused().then(function(paused) {
                var fullScreen = document.querySelector('.full-video-player');
                if(!paused){
                    
                    player.pause();
                    embedWrap.classList.remove('playing');
                   
                    if(fullScreen){
                        // document.body.classList.remove('playing-started');
                    }

                }else{
                    player.play();
                    embedWrap.classList.add('playing');
                    if(fullScreen){
                        document.body.classList.add('playing-started');
                    }
                }
            });
        });

        player.getVolume().then(function(volume) {

            if(!volume){
                embedWrap.classList.add('muted');
            }
        });

        player.on("progress", function(data){
            loadProgress.style.width = (data.percent * 100) + '%';
        });


        player.on("play", function(data) {
            
            window.killTimer = false;

            document.body.classList.remove('playlist-hover');

            duration = data.duration;

            let timecode = secondsToTimecode(duration);
            durationNumElm.innerHTML = timecode;

            embedWrap.classList.add('played');
            embedWrap.classList.add('playing');

            var fullScreen = document.querySelector('.full-video-player');
            var topWrap = document.querySelector('.top-wrap');
            if(fullScreen){
                document.body.classList.add('playing-started');
                addThenRemoveAfterDelay(document.body, 'show-controls', 3000);
            }else{
                addThenRemoveAfterDelay(embedWrap, 'show-controls', 3000);
            }


            if(topWrap){
                let meta = document.querySelector('.video-meta');
                meta.classList.add('played');
            }
            

        });

        player.on("pause", function(data) {
            embedWrap.classList.remove('playing');
        });

        player.on("bufferstart", function(data) {
            embedWrap.classList.remove('played');
        });
        
        player.on("bufferend", function(data) {
            embedWrap.classList.add('played');
        });


        player.on("ended", function(data) {
            if(!fullScreen){
                embedWrap.classList.remove('played');
                embedWrap.classList.remove('playing');
                embedWrap.classList.remove('trig');
                embedWrap.removeEv('mousemove', restartTimer);
            }else{
                player.setCurrentTime(0);
                document.body.classList.add('playlist-hover');
                embedWrap.classList.remove('playing');
                document.body.classList.add('show-controls');
            }
        });
    
        player.on("timeupdate", function(data) {
            if (data.seconds - 1 < timeWatched && data.seconds > timeWatched) {
                timeWatched = data.seconds;

                let timecode = secondsToTimecode(timeWatched);
                timeWatchedNumElm.innerHTML = timecode;

                timeWatchedElm.style.width = (data.percent * 100) + '%';
            }

            window.curTime = data.seconds;

            // expandButton.setAttribute("href", updateURLParameter(expandButton.href, 'time', data.seconds));

        });
    
        player.on("seeked", function(data) {
            timeWatched = data.seconds;
        });
        
    };

};


function step() {

    if(document.fullscreenElement === null){
        document.body.classList.remove('fullscreen-mode');
    }else{
        document.body.classList.add('fullscreen-mode');
    }
    window.requestAnimationFrame(step);
}

window.requestAnimationFrame(step);


function updateURLParameter(url, param, paramVal){
    var newAdditionalURL = "";
    var tempArray = url.split("?");
    var baseURL = tempArray[0];
    var additionalURL = tempArray[1];
    var temp = "";
    if (additionalURL) {
        tempArray = additionalURL.split("&");
        for (var i=0; i<tempArray.length; i++){
            if(tempArray[i].split('=')[0] != param){
                newAdditionalURL += temp + tempArray[i];
                temp = "&";
            }
        }
    }

    var rows_txt = temp + "" + param + "=" + paramVal;
    return baseURL + "?" + newAdditionalURL + rows_txt;
}

function addThenRemoveAfterDelay(elm, className, delay){

    elm.removeEventListener('mousemove', restartTimer);
    elm.addEventListener('mousemove', restartTimer);

    elm.classList.add(className);
    var timer = false;

    startTimer()

    function startTimer(){
        timer = setTimeout(function(){
            if(elm.querySelector('.playing')){
                elm.classList.remove(className);
            }
        }, delay);
    };

    function restartTimer(){

        if(!window.killTimer ){
            elm.classList.add(className);
            if(timer){
                clearTimeout(timer);
            }
            startTimer();
        }else{
            window.killTimer = false;
            elm.removeEventListener('mousemove', restartTimer);
        }
    };
    
};

function secondsToTimecode(seconds) {
    var hours = Math.floor(seconds / 3600);
    var minutes = Math.floor((seconds - (hours * 3600)) / 60);
    var seconds = Math.floor(seconds - (hours * 3600) - (minutes * 60));
    var timecode = '';

    if (hours > 0) {
        timecode += ('0' + hours).slice(-2) + ':';
    }

    timecode += ('0' + minutes).slice(-2) + ':';
    timecode += ('0' + seconds).slice(-2);

    return timecode;
}

function pad(num, size) {
    num = num.toString();
    while (num.length < size) num = "0" + num;
    return num;
}

function updateTrack(e, element, marker, duration){
    let per = getMousePercentage(e, element);
    let seconds = duration*per.x;
    let timecode = secondsToTimecode(seconds);
    marker.style.left = (per.x*100) + '%';
    marker.innerHTML = timecode;

    return seconds;
}

function getMousePercentage(e, element) {
    var rect = element.getBoundingClientRect();
    var x = e.clientX - rect.left;
    var y = e.clientY - rect.top;
    return {x: x / rect.width, y: y / rect.height};
  }



  var touchsurface = window,
    startX,
    startY,
    dist,
    threshold = 50, 
    allowedTime = 200, 
    elapsedTime,
    startTime

touchsurface.addEventListener('touchstart', function(e){
  touchsurface.innerHTML = ''
  var touchobj = e.changedTouches[0]
  dist = 0
  startX = touchobj.pageX
  startY = touchobj.pageY
  startTime = new Date().getTime() 

//   if(document.querySelector('.playlist')){
//     console.log(e)
//     e.preventDefault();
//   }

}, false)

touchsurface.addEventListener('touchmove', function(e){
    // if(document.querySelector('.playlist')){
    //     e.preventDefault();
    // }
}, false)

touchsurface.addEventListener('touchend', function(e){
  var touchobj = e.changedTouches[0]
  dist = touchobj.pageY - startY // get total dist traveled by finger while in contact with surface
  elapsedTime = new Date().getTime() - startTime // get time elapsed
  // check that elapsed time is within specified, horizontal dist traveled >= threshold, and vertical dist traveled <= 100
 
  var swipeUptBol = (elapsedTime <= allowedTime && dist >= threshold && Math.abs(touchobj.pageX - startX) <= 100);
  var swipeDowntBol = (elapsedTime <= allowedTime && (dist*-1) >= threshold && Math.abs(touchobj.pageX - startX) <= 100);

  if(swipeUptBol){

    if(document.querySelector('.playlist')){
        document.body.classList.remove('playlist-hover');
    }        
  }

  if(swipeDowntBol){
    if(document.querySelector('.playlist')){
        document.body.classList.add('playlist-hover');
    }        
  }

//   handleswipe(swiperightBol)


//   e.preventDefault()
}, false)


export default video;